import { Icon } from '@chakra-ui/react';

export const CustomPassMultiIcon = (props) => (
  <Icon
    fill="none"
    {...props}
    viewBox="0 0 24 32"
    width="31px"
    height="31px"
    ml="-3px"
  >
    <rect
      className="strokeBrandElToDark darkBgElToBrand"
      x="0.75"
      y="0.75"
      width="22.119"
      height="30.5"
      rx="4.25"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      fill="none"
    />
    <path
      className="multicolorElToDark darkBgElToBrand"
      d="M8.38086 20.4445V22.5609C8.38086 22.9122 8.66446 23.1958 9.01578 23.1958H11.1322C11.4835 23.1958 11.7671 22.9122 11.7671 22.5609V20.4445C11.7671 20.0932 11.4835 19.8096 11.1322 19.8096H9.01578C8.66446 19.8096 8.38086 20.0932 8.38086 20.4445ZM9.22742 20.6561H10.9205V22.3493H9.22742V20.6561ZM8.38086 26.7937C8.38086 27.145 8.66446 27.4286 9.01578 27.4286H11.1322C11.4835 27.4286 11.7671 27.145 11.7671 26.7937V24.6773C11.7671 24.326 11.4835 24.0424 11.1322 24.0424H9.01578C8.66446 24.0424 8.38086 24.326 8.38086 24.6773V26.7937ZM9.22742 24.8889H10.9205V26.5821H9.22742V24.8889ZM15.365 19.8096H13.2486C12.8973 19.8096 12.6137 20.0932 12.6137 20.4445V22.5609C12.6137 22.9122 12.8973 23.1958 13.2486 23.1958H15.365C15.7163 23.1958 15.9999 22.9122 15.9999 22.5609V20.4445C15.9999 20.0932 15.7163 19.8096 15.365 19.8096ZM15.1533 22.3493H13.4602V20.6561H15.1533V22.3493ZM12.6137 24.0424H13.4602V24.8889H12.6137V24.0424ZM13.4602 24.8889H14.3068V25.7355H13.4602V24.8889ZM12.6137 25.7355H13.4602V26.5821H12.6137V25.7355ZM14.3068 25.7355H15.1533V26.5821H14.3068V25.7355ZM15.1533 26.5821H15.9999V27.4286H15.1533V26.5821ZM13.4602 26.5821H14.3068V27.4286H13.4602V26.5821ZM14.3068 24.0424H15.1533V24.8889H14.3068V24.0424ZM15.1533 24.8889H15.9999V25.7355H15.1533V24.8889Z"
      fill="#FFFFFF"
    />
    <line
      className="strokeBrandElToDark darkBgElToBrand"
      x1="1.52393"
      y1="6.86914"
      x2="23.6716"
      y2="6.86914"
      stroke="#FFFFFF"
      strokeWidth="1.5"
    />
    <line
      className="strokeBrandElToDark darkBgElToBrand"
      x1="1.55005"
      y1="15.25"
      x2="23.6978"
      y2="15.25"
      stroke="#FFFFFF"
      strokeWidth="1.5"
    />
  </Icon>
);
